/* global  */ // tUrl等のグローバル変数を宣言する
import './_smoothScroll' // スムーズスクロール
// import Swiper from 'swiper' // Swiper
// import PerfectScrollbar from 'perfect-scrollbar' // 独自スクロールバー
// position:styckyのポリフィル
// Stickyfill.add(document.querySelectorAll('.sticky'))

jQuery(function($) {
  let accBtn = 'sp-menu' // このIDを基準としたアコーディオン
  $('#' + accBtn + '-open,.' + accBtn + '-close,#' + accBtn + ' a,#overlay').on('click', function() {
    $('#' + accBtn + ',#' + accBtn + '-open,.' + accBtn + '-close,#overlay').toggleClass('active')
  })

  $('.linkcheck')
    .find('a')
    .each(function() {
      //アクティブ検証
      var ct = location.href.replace(location.hash, '') //カレントURL取得（#ID除外）
      var ac = $(this)
        .attr('href')
        .replace(/#.*/gi, '') //href取得（#ID除外）
      if (ac === ct) {
        //カレントURLとhrefが同じならactive付加
        $(this).addClass('current')
      }
    })

  var name = 'spmenu' //このIDを基準としたアコーディオン
  $('#' + name + '-open,#' + name + '-close').click(function() {
    $('#' + name + ',#' + name + '-open').toggleClass('active')
    $('.l-nav').slideToggle()
  })

  $('.accordion').each(function() {
    //CSS汎用アコーディオン
    var ac = $(this)
    ac.find('.btn,.close').click(function() {
      ac.find('.btn,.ac-body').toggleClass('active')
    })
  })

  function trunk8() {
    $('.js-t8,.bread').trunk8({
      //指定要素に行数制限をかける
      lines: 2,
      fill: '...'
    })
    $('.js-t8.line1').trunk8({
      //指定要素に行数制限をかける
      lines: 1,
      fill: '...'
    })
    $('.js-t8.line3').trunk8({
      //指定要素に行数制限をかける
      lines: 3,
      fill: '...'
    })
  }
  trunk8()
  $(window).on('load resize ', function() {
    trunk8()
  })
  //クリップボードにコピー
  $('#copy-one').on('click', function() {
    $('#text-one').select()
    document.execCommand('copy')
  })
  $('#copy-two').on('click', function() {
    $('#text-two').select()
    document.execCommand('copy')
  })

  $(window).on('load scroll resize', function() {
    //ある程度スクロールしたらメニューボタン表示
    var fixedHeader = $('.l-header.fixed')
    var menuScrollPos = 200
    if ($(this).scrollTop() > menuScrollPos) {
      $(fixedHeader).addClass('is-show')
    } else {
      $(fixedHeader).removeClass('is-show')
    }
  })

  //トップページのメインビジュアル
  /* global TURL */
  $('.p-top .l-mv.pc').bgSwitcher({
    images: [
      '' + TURL + '/img/top_mv_bg_01.jpg',
      '' + TURL + '/img/top_mv_bg_02.jpg',
      '' + TURL + '/img/top_mv_bg_03.jpg',
      '' + TURL + '/img/top_mv_bg_04.jpg'
    ]
  })
  $('.p-top .l-mv.sp').bgSwitcher({
    images: [
      '' + TURL + '/img/top_mv_bg_01_sp.jpg',
      '' + TURL + '/img/top_mv_bg_02_sp.jpg',
      '' + TURL + '/img/top_mv_bg_03_sp.jpg',
      '' + TURL + '/img/top_mv_bg_04_sp.jpg'
    ]
  })

  $('.js-comics-slider')
    .on('init', function(event, slick) {
      $('.slick-counter .current').text(slick.currentSlide + 1)
      $('.slick-counter .total').text(slick.slideCount)
      $('.comics-pager .prev').css('visibility', 'hidden')
    })
    .slick({
      dots: false,
      infinite: false,
      speed: 300,
      autoplay: false,
      fade: false,
      arrows: true,
      prevArrow: '.comics-pager .prev',
      nextArrow: '.comics-pager .next'
    })
    .on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      $('.slick-counter .current').text(nextSlide + 1)
    })
    .on('afterChange', function(event, slick, currentSlide, nextSlide) {
      if (currentSlide + 1 === slick.slideCount) {
        $('.comics-pager .next').css('visibility', 'hidden')
      } else {
        $('.comics-pager .next').css('visibility', 'visible')
      }
      if (currentSlide !== 0) {
        $('.comics-pager .prev').css('visibility', 'visible')
      } else {
        $('.comics-pager .prev').css('visibility', 'hidden')
      }
    })
})
